<template>
    <div class="order">
        <div class="search m-b-20">
            <div class="search-box flex-row">
                <img class="searchImg" :src="search" alt="" >
                <input class="searchVal" placeholder="请输入订单号搜索" v-model="value" type="text">
            </div>
        </div>
        <div class="order-main" v-for="(data, indexs) in orderList" :key="indexs">
            <div class="order-title">订单号：{{ data.orderNumber }}</div>    
        <ul class="orderList  m-t-20" >
            <li class="item m-b-20" v-for="(item, index) in data.list" :key="index" @click="viewPage(item)">
                <!-- <div class="title brder-b flex-row">
                    <p class="orderNumber">订单号：{{item.orderNumber}}</p>
                </div> -->
                <div class="product m-t-25">电子收据号：{{item.electronicReceiptNumber}}</div>
                <div class="product m-t-25">电子收据状态：{{item.status == 0 ? '有效' : '作废'}}</div>
                <!-- <div class="product m-t-25">收据号：{{item.collectMoneyName}}</div> -->
                <div class="product m-t-25">收款方式：{{item.collectWay}}</div>
                <div class="product m-t-25">收款金额：{{item.amount}}</div>                
            </li>
        </ul>
        </div>
    </div>
</template>
<script>
import search from '@/assets/img/search.png';
import product from '@/assets/img/product.jpg';
import tel from '@/assets/img/tel.png';
import { listElectronicReceipt } from '@/api/index';
import receiving from '@/assets/img/收货@3x.png';
export default {
    data(){
        return {
            search,
            product,
            tel,
            value:'',
            orderList:[],
            orderListAll: [],
            item:{

            }
        }
    },
    created(){
        this.$loca.setItem('routeItem', this.$route.path);
        this.getData();
    },
    watch:{
        value(val){
            if(val){
                this.orderList = this.orderListAll.filter(item=>item.orderNumber.indexOf(val) != -1)
            }else{
                this.orderList = this.orderListAll;
            }
        }
    },
    methods:{
        viewPage(item){
            this.$router.push({path:'viewPdfs',query:{item: JSON.stringify(item)}});
        },
        /**
         * 获取订单列表
         * @method getData
         */
        getData(){
            let data = this.$loca.getItem('phone');
            listElectronicReceipt({customerPhone: data}).then(res => {
                let orderArr = []; //订单号的数组
                res.data.map(item=>{
                    let isTrue = orderArr.some(o => o.orderNumber === item.orderNumber);
                    if(isTrue){
                        orderArr.map(attr=>{
                            if(item.orderNumber === attr.orderNumber){
                                attr.list.push(item);
                            }
                        })
                    }else{
                        console.log(item);
                        orderArr.push({
                            orderNumber: item.orderNumber,
                            list: [item]
                        })
                    }
  
                })
                this.orderList = orderArr;
                this.orderListAll = orderArr;
            }).catch(error => {
                console.log('获取收据');
            })
            // let res = {"status":200,"message":null,"data":{"total":4,"rows":[{"collectWay":"现金","customerPhone":"3564213568","collectType":"预付款","amount":1234.00,"orderNumber":"SO2112213681","address":"北京市朝阳区朝阳公园南路10号院1~7号楼地下室2层b201~220室_T11生鲜超市(朝阳公园店)#1#1#1","electronicReceiptNumber":"DD1","collectMoneyName":"MC2112212012","customerName":"ggggg","url":"http://fanhuayiju.oss-cn-beijing.aliyuncs.com/DD1.pdf","status":0},{"collectWay":"现金","customerPhone":"3564213568","collectType":"预付款","amount":1234.00,"orderNumber":"SO2112213681","address":"北京市朝阳区朝阳公园南路10号院1~7号楼地下室2层b201~220室_T11生鲜超市(朝阳公园店)#1#1#1","electronicReceiptNumber":"DD1","collectMoneyName":"MC2112212012","customerName":"ggggg","url":"http://fanhuayiju.oss-cn-beijing.aliyuncs.com/DD1.pdf","status":0},{"collectWay":"现金","customerPhone":"3564213568","collectType":"预付款","amount":1234.00,"orderNumber":"SO2112213681","address":"北京市朝阳区朝阳公园南路10号院1~7号楼地下室2层b201~220室_T11生鲜超市(朝阳公园店)#1#1#1","electronicReceiptNumber":"DD1","collectMoneyName":"MC2112212012","customerName":"ggggg","url":"http://fanhuayiju.oss-cn-beijing.aliyuncs.com/DD1.pdf","status":0},{"collectWay":"现金","customerPhone":"3564213568","collectType":"预付款","amount":1234.00,"orderNumber":"SO2112213681","address":"北京市朝阳区朝阳公园南路10号院1~7号楼地下室2层b201~220室_T11生鲜超市(朝阳公园店)#1#1#1","electronicReceiptNumber":"DD2","collectMoneyName":"MC2112212012","customerName":"ggggg","url":"http://fanhuayiju.oss-cn-beijing.aliyuncs.com/DD2.pdf","status":0}]}}
            //  this.orderList = res.data.rows;
            //  this.orderListAll = res.data.rows;
        },
    }
}
</script>
<style lang="scss" scoped>
.order{
    background: $color-ed;
    .search{
        height: 82px;
        background: $ffff;
        .search-box{
            width:670px;
            height:60px;
            background:rgba(255,255,255,1);
            border:2px solid rgba(229,229,229,1);
            border-radius:10px;
            margin:18px 0 0 39px;
            align-items: center;
            .searchImg{
                margin-left: 17px;
                width: 24px;
                height: 24px;
            }
            .searchVal{
                margin-left: 18px;
                width: 600px;
                height: 100%;
            }
        }
    }
    .order-main{
        width: 97%;
        margin: 0 auto;
        overflow: hidden;
        border: solid 5px #ccc;
        box-shadow: 5px 5px 5px #f0f0f0;
        margin-bottom: 40px;
        .order-title{
            background: #f0f0f0;
            font-weight: bold;
            color: #666;
            font-size: 30px;
            line-height: 70px;
            text-indent: 20px;
            height: 70px;
            box-shadow: 5px 5px 5px #ccc;
        }
        ul{
            width: 100%;
            float: right;
        }
    }
    .orderList{
        background: $color-ed;
        .item{
            // height: 334px;
            background: $ffff;
            padding: 10px 20px;
            padding-bottom: 10px;
            &:last-child{
                margin-bottom: 0;
            }
            .title{
                padding: 18px 0 15px 0; 
                justify-content: space-between;
                .orderNumber{
                    font-size:28px;
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                }
                .orderStats{
                    font-size:20px;
                    color:rgba(86,180,240,1);
                    margin-right: 11px;
                    span{
                        margin-left: 15px;
                    }
                }
            }
            .product{
                padding-left: 14px;
                font-size:24px;
                color: $color-102;
                justify-content: space-between;
                align-items: center;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-153;
                }
            }
            .products{
                margin-left: 14px;
                font-size:24px;
                color: $color-102;
                align-items: center;
                position: relative;
                .time{
                    margin-right: 11px;
                    font-size:20px;
                    color:$color-187;
                }
                .numbers{
                    font-size:24px;
                    color:$color-81;
                }
                .invoice{
                    margin-right: 11px;
                    font-size:20px;
                    position: absolute;
                    left: 350px;
                }
            }
            .info{
                padding: 16px 0 10px 0;
                font-size:24px;
                color:$color-153;
                width: auto;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 54px;
                    height: 54px;
                }
                .information{
                    align-items:center;
                    .names{
                        margin-bottom: 7px;
                    }
                    img{
                        width: 65px;
                        height: 65px;
                        margin: 0 25px 0 21px;
                    }
                }
            }
        }
    }
}
.border-bottom{
    border-bottom:2px solid rgba(229,229,229,1);
}
.delivery{
    color:$color-162;
}
</style>

